import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

import useSettings from '../hooks/useSettings';
import Icon from '../Icon';

interface ListRefreshButtonProps {
	isLoading: boolean;
	updateRefresh: () => void;
}

export default function ListRefreshButton({ isLoading, updateRefresh }: ListRefreshButtonProps) {
	const { t } = useSettings();

	const [openTooltip, setOpenTooltip] = React.useState(false);

	return (
		<Tooltip
			title={t('VIEW_HEADER_BUTTON_REFRESH')}
			arrow
			open={!isLoading && openTooltip}
			onOpen={() => setOpenTooltip(true)}
			onClose={() => setOpenTooltip(false)}
		>
			<IconButton size="small" onClick={updateRefresh} disabled={isLoading}>
				<Icon className={isLoading ? 'animate-spin' : ''} icon="sync" />
			</IconButton>
		</Tooltip>
	);
}
